export const SYSTEM_ROLES = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  MANAGER: "manager",
  MARKETING_LEAD: "marketing_lead",
  TEAM_LEADER: "team_leader",
  AGENT: "agent",
  SITE_VISIT_EXECUTIVE: "site_visit_executive",
  SALES_MANAGER: "sales_manager",
  SALES_PERSON: "sales_person",
  GENERAL_MANAGER: "general_manager",
  DIRECTOR: "director",
  MANAGING_DIRECTOR: "managing_director",
  HR: "hr",
  ASSISTANT_MANAGER: "assistant_manager",
} as const;

export type SystemRoleId = (typeof SYSTEM_ROLES)[keyof typeof SYSTEM_ROLES];
